<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import PatientAddEditForm from "@/components/models/patient/forms/PatientAddEditForm.vue";
import { usePatient } from "@/composables/models/patient/usePatient";
import { usePageTitle } from "@/composables/shared/usePageTitle";
import { patientSelectable } from "@/api/models/patient/patient";
import { useAbility } from "@casl/vue";
import { useUrlParams } from "@/composables/shared/filters/useUrlSearch";

definePage({
  meta: {
    title: "generic.action.editEntity",
    titleParams: { entity: "generic.entity.patient" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.UPDATE, $permSubjects.PATIENT__PATIENT);
    },
  },
});

const { id } = useUrlParams({ id: String });

const { data: patient, isLoading: isPatientLoading } = usePatient({ id: id });
usePageTitle({
  entityRef: patient,
  selectable: patientSelectable,
});
</script>

<template>
  <loading v-if="isPatientLoading" />
  <patient-add-edit-form
    v-else
    :patient="patient"
  />
</template>

<style scoped></style>
